import React from "react";
import {Helmet} from "react-helmet";

const Seo = (props) => {

    return (
        <>
        {typeof props.data.seo !== 'undefined' && props.data.seo.title[props.lang] !== null? (
            <Helmet>
                <title>{props.data.seo.title[props.lang]}</title>
                <meta name="description" content={props.data.seo.description[props.lang]} />
            </Helmet>
        ):(
            <Helmet>
                <title>{props.data['title_' + props.lang]}</title>
                <meta name="description" content={props.data['title_' + props.lang]} />
            </Helmet>
        )}
        </>
    )
}

export default Seo;